// extracted by mini-css-extract-plugin
export default {"PartyList":"PartyList_PartyList__gHWRb"};